import React from "react";
import { Query } from "react-apollo";
import { Platform, View } from "react-native";
import { Grid, Section } from "react-native-responsive-layout";
import styled from "styled-components/native";
import { Button, Form, FormCell } from "cci-component";
import { withRouter, encodeObjectToUrl } from "cci-utility";
import { getConnectionInfoQuery } from "cci-logic";
import { PageTitle } from "../layout/Titles";

const Wrapper = styled(View)`
  padding: ${props => props.theme.pageContentMarginTop}px
    ${props => props.theme.pagePadding}px;
`;

// TODO This is a Chrome only print method, we must find something decent for other browsers and native
const printHack = url => {
  let printFrame = document.getElementById("printer");
  if (!printFrame) {
    printFrame = document.createElement("iframe");
    printFrame.id = "printer";
    printFrame.style.display = "none";
    document.body.appendChild(printFrame);
  }

  printFrame.setAttribute("src", url);
};

/**
 * Shows the options that are needed to run a BIRT report on the server side.
 */
const ReportOptions = ({
  style,
  history,
  reportName,
  previewPath,
  title,
  children,
  downloadFileType = "xls",
  previewButtonTitle,
  ...restProps
}) => (
  <Query query={getConnectionInfoQuery} errorPolicy="none">
    {({ error, data: { ConnectionInfo: connectionInfo } }) => (
      <Form {...restProps}>
        {({ form }) => (
          <Wrapper style={style}>
            <Grid style={{ alignItems: "stretch" }} scrollable stretchable>
              {/* Page title */}
              {title && <PageTitle title={title} lgStyle={{ marginLeft: 0, marginTop: 20 }} />}

              {/* Content */}
              {children}

              <Section>
                <FormCell style={{ flexDirection: "row" }}>
                  {/* Print button that shows the print dialog */}
                  {Platform.OS === "web" && (
                    <Button
                      rightIcon="print"
                      onPress={() =>
                        printHack(
                          `${
                            connectionInfo.appUrl
                          }/report/printPdf?reportName=${reportName}&${encodeObjectToUrl(
                            form.getState().values
                          )}`
                        )
                      }
                    />
                  )}

                  {/* Excel button that downloads spreadsheet */}
                  {Platform.OS === "web" && (
                    <Button
                      rightIcon="download"
                      margins="0 6px"
                      onPress={() =>
                        window.open(
                          `${
                            connectionInfo.appUrl
                          }/report/${downloadFileType}?reportName=${reportName}&${encodeObjectToUrl(
                            form.getState().values
                          )}`,
                          "_blank"
                        )
                      }
                    />
                  )}

                  {/* This view allows us to align items to the right. */}
                  <View style={{ flex: 1, alignItems: "flex-end" }}>
                    {/* Preview button shows the report using the options on the right hand side prior to being printed */}
                    <Button
                      title={previewButtonTitle || "Preview"}
                      rightIcon="chevron-right"
                      // TODO If react-router supported relative paths, the previewPath prop would not be necessary. https://github.com/ReactTraining/react-router/issues/5127
                      onPress={() =>
                        history.push(
                          `${previewPath}/preview/${encodeObjectToUrl(
                            form.getState().values
                          )}`
                        )
                      }
                    />
                  </View>
                </FormCell>
              </Section>
            </Grid>
          </Wrapper>
        )}
      </Form>
    )}
  </Query>
);

export default withRouter(ReportOptions);
